import { getCsvFileName } from '../getCsvFileName'

export const getCsvFromFile = (file: File) => {
  return {
    csvFile: file,
    extension: 'csv',
    fileName: getCsvFileName(file)
  }
}
